import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import SettingsIcon from '@mui/icons-material/Settings';
import { CreatedPageContainer, ChatContainer, ChatWrapper } from './CreatedPage.styled';
import { useAgent } from '../../context';
import { useStore } from '../../../../../hooks';
import ChatComponentPersistent from '../../../PMSystemPage/components/ChatComponent/ChatComponentPersistent';
import { ChatProvider } from '../../../PMSystemPage/context/ChatContext';

const CreatedPage = () => {
  const { agentId } = useParams();
  const { authStore } = useStore();
  const { agent } = useAgent();

  // Configuración del placeholder para el chat de creación
  const buildAgentPlaceholderConfig = useMemo(() => ({
    placeholderTitle: 'Build your Agent with AI support',
    placeholderDescription: "You don't need to fill out forms. Just start typing what you need, and we will guide you step by step to create a personalized Agent.",
    placeholderIcon: SettingsIcon,
    showDefaultPlaceholder: true,
  }), []);

  // Configuración HTTP
  const httpOptions = useMemo(() => ({
    tenantId: authStore.selectedAccount?.tenantId || 'default-tenant',
    senderUuid: authStore.selectedAccount?.id,
    assistantUuid: agentId,
  }), [authStore.selectedAccount, agentId]);

  // Datos del agente para el chat
  const agentData = useMemo(() => ({
    id: agentId,
    customerId: authStore.selectedAccount?.id,
    jobTitle: '',
    persona: { name: '' },
    tone: [],
    conversationStarters: agent.starters || [],
    extendedAnswer: false,
    scope: '',
    actions: [],
    actionsSettings: [],
    name: agent.name || 'Agent',
    knowledgeBase: [],
    humanInstructions: agent.instructions || '',
    prompt: '',
    addToConcierge: false,
    channels: [],
    fullInstructions: '',
    guardrails: [],
    features: [],
    instructionRef: [],
    status: agent.status || 'active',
    photoUrl: agent.metadata?.imageUrl || '',
    model: agent.model || '',
    category: agent.category || '',
    signature: { EMAIL: '' },
    type: agent.type || 'assistant',
    promptId: '',
    createdBy: '',
  }), [agentId, authStore.selectedAccount, agent]);

  return (
    <CreatedPageContainer>
      <ChatContainer>
        <ChatWrapper>
          <ChatProvider
            communicationType="http"
            httpOptions={httpOptions}
          >
            <ChatComponentPersistent
              customerSelected={authStore.selectedAccount?.id}
              agentId={agentId}
              agentDomain="assistant"
              inputWidth="100%"
              metadata={{}}
              handleMetadata={() => {}}
              agentData={agentData}
              {...buildAgentPlaceholderConfig}
            />
          </ChatProvider>
        </ChatWrapper>
      </ChatContainer>
    </CreatedPageContainer>
  );
};

export default CreatedPage;

